import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from '@/stores/auth-store';

export function ProtectedRoute() {
  const token = useAuthStore((s) => s.token);
  const loading = useAuthStore((s) => s.loading);
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!token) {
    // After explicit logout, don't pass `from` state (prevents cross-user route leakage).
    const wasExplicitLogout = sessionStorage.getItem('scio3_staff_explicit_logout');
    return (
      <Navigate
        to="/staff/login"
        state={wasExplicitLogout ? undefined : { from: location }}
        replace
      />
    );
  }

  return <Outlet />;
}
